export default {"src":"/_next/static/media/MyTasks.c3b71c50.svg","height":22,"width":24,"blurWidth":0,"blurHeight":0};